import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import TimeUtils from '../../utils/TimeUtils';

export interface PlannerTimerInformation {
  plannerTimerInformation: {
    time?: any | null; //hora de salida con formato HH::MMam
    date?: any | null; //fecha de salida con formato dia/mes/año
    arriveBy: boolean; //true tiempo de llegada, false tiempo de salida
    now: boolean; //identificación de si se ha escogido la hora actual
    leavesAt: boolean;
    intermediateStopTimes: Array<string | undefined>; //tiempos de salida en las paradas intermedias
  }
}

const initialState : PlannerTimerInformation = {
  plannerTimerInformation: {
    time: TimeUtils.getTimePM_AM(TimeUtils.getTime(Date.now())),
    date: TimeUtils.getDate(Date.now()),
    arriveBy: false,
    now: true,
    leavesAt: false,
    intermediateStopTimes: new Array<string>(),
  },
};

export const plannerTimerSlice = createSlice({
  name: 'plannerTimer',
  initialState,
  reducers: {
    updateTime: (state, action) => {
      state.plannerTimerInformation.time = TimeUtils.getTimePM_AM(action.payload);
    },
    updateDate: (state, action) => {
      state.plannerTimerInformation.date = action.payload;
    },
    updateArriveBy: (state, action) => {
      state.plannerTimerInformation.arriveBy = action.payload;
    },
    updateNow: (state, action) => {
      if (action.payload) {
        state.plannerTimerInformation.date = initialState.plannerTimerInformation.date;
        state.plannerTimerInformation.time = initialState.plannerTimerInformation.time;
      }
      state.plannerTimerInformation.now = action.payload;
    },
    updateIntermediateStopTimes: (state, action) => {
      state.plannerTimerInformation.intermediateStopTimes = action.payload;
    },
    updateLeavesAt: (state, action) => {
      state.plannerTimerInformation.leavesAt = action.payload;
    },

  },
});


export const { updateLeavesAt, updateArriveBy, updateNow, updateTime, updateDate } = plannerTimerSlice.actions;


export const plannerTimerInformation = (state: RootState) => state.plannerTimer.plannerTimerInformation;
